import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAppConfig } from './AppConfigProvider';
import axiosInstance from '../utils/axiosConfig';

const ManualSubmitModal = ({ visible, onClose, erpInvoiceId, onRefresh }) => {
  const { t } = useTranslation();
  const { theme } = useAppConfig();
  const [form] = Form.useForm();
  const [uploading, setUploading] = useState(false);
  const einvoiceId = Form.useWatch('einvoiceId', form);

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (!erpInvoiceId) {
        message.error(t('manualSubmit.noErpInvoice'));
        return;
      }
      setUploading(true);
      await axiosInstance.post(`/invoice/${erpInvoiceId}/offline-backfill`, {
        eInvoiceId: values.einvoiceId,
      });
      message.success(t('manualSubmit.success'));
      onClose();
      if (typeof onRefresh === 'function') {
        onRefresh();
      }
    } catch (err) {
      if (err?.errorFields) {
        return;
      }
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err.message;
      message.error(errorMessage || t('manualSubmit.failed'));
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal
      open={visible}
      title={t('manualSubmit.title')}
      onCancel={onClose}
      footer={[
        <Button
          key="cancel"
          onClick={onClose}
          style={{
            borderColor: theme.primary,
            color: theme.primary,
          }}
        >
          {t('common.cancel')}
        </Button>,
        <Button
          key="upload"
          type="primary"
          loading={uploading}
          disabled={!einvoiceId}
          onClick={handleOk}
          style={{
            backgroundColor: einvoiceId ? theme.primary : '#E0E0E0',
            color:'#ffffff'
          }}
        >
          {t('manualSubmit.uploadButton')}
        </Button>,
      ]}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t('invoice.einvoiceId')}
          name="einvoiceId"
          rules={[{ required: true, message: t('manualSubmit.einvoiceIdRequired') }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ManualSubmitModal;

